// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type AanvragenDomainEntitiesMuterenMutatieActie =
  (typeof AanvragenDomainEntitiesMuterenMutatieActie)[keyof typeof AanvragenDomainEntitiesMuterenMutatieActie];

export const AanvragenDomainEntitiesMuterenMutatieActie = {
  Geen: 'Geen',
  Muteren: 'Muteren',
  MuterenIngangsdatum: 'MuterenIngangsdatum',
  Royeren: 'Royeren',
} as const;
